import { TFunction } from 'react-i18next';
import { ILists } from '../../interfaces/merchant';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { FINANCIAL_ACCOUNT_FORM_FIELD, FINANCIAL_ACCOUNT_FORM_FIELD_NAMES } from './financial-account-form';

interface IFinancialAccountInputsProps {
  lists: ILists
  t: TFunction;
}

export const FINANCIAL_ACCOUNT_INPUTS = ({ lists, t }: IFinancialAccountInputsProps): IFormInputProps[] => [
  {
    key: FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_TYPE,
    fieldName: FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_TYPE,
    placeholder: t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.ACCOUNT_TYPE),
    label: t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.ACCOUNT_TYPE),
    inputType: InputType.Select,
    searchable: false,
    data: lists.ddaType,
    dataCy :'dda',
    additionalClasses: 'col-sm-6 col-md-6'
  },
  {
    key: FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_NUMBER,
    fieldName: FINANCIAL_ACCOUNT_FORM_FIELD.ACCOUNT_NUMBER,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.ACCOUNT_NUMBER)}`,
    label: t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.ACCOUNT_NUMBER),
    inputType: InputType.Text,
    additionalClasses: 'col-sm-6 col-md-6'
  },
  {
    key: FINANCIAL_ACCOUNT_FORM_FIELD.ROUTING_NUMBER,
    fieldName: FINANCIAL_ACCOUNT_FORM_FIELD.ROUTING_NUMBER,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.ROUTING_NUMBER)}`,
    label: t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.ROUTING_NUMBER),
    inputType: InputType.Text,
    additionalClasses: 'col-sm-6 col-md-6'
  },
  {
    key: FINANCIAL_ACCOUNT_FORM_FIELD.BANK_NAME,
    fieldName: FINANCIAL_ACCOUNT_FORM_FIELD.BANK_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.BANK_NAME)}`,
    label: t(FINANCIAL_ACCOUNT_FORM_FIELD_NAMES.BANK_NAME),
    inputType: InputType.Text,
    additionalClasses: 'col-sm-6 col-md-6'
  },
];
